
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import {
  trackLandingBannerClick,
  trackLandingBannerImpression,
} from '@tracking/events'

export default {
  components: {
    RevIllustration,
    RevIllustrationSource,
    RevCard,
  },

  props: {
    position: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      cardMarketingContent: 'landing/cardMarketingContent',
    }),
    hasUrl() {
      return !isEmpty(this.cardMarketingContent.link)
    },
    isExternalLink() {
      return (
        this.hasUrl && /^https?:\/\//.test(this.cardMarketingContent.link.url)
      )
    },
    wrapperImageTag() {
      return this.hasUrl ? RevButtonBase : 'div'
    },
    wrapperImageProps() {
      return this.hasUrl
        ? {
            'aria-label': this.cardMarketingContent.link.text,
            to: this.cardMarketingContent.link.url,
            target: this.isExternalLink ? '_blank' : '_self',
          }
        : {}
    },
    eventType() {
      return this.hasUrl ? 'click' : null
    },
  },

  watch: {
    $route() {
      this.watchAdvertInViewport()
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  mounted() {
    this.watchAdvertInViewport()
  },

  methods: {
    trackClick() {
      trackLandingBannerClick({
        name: 'landing_page',
        creative: this.cardMarketingContent.alt,
        position: `landing_page_${this.position}`,
      })
    },
    watchAdvertInViewport() {
      if (!isEmpty(this.cardMarketingContent)) {
        this.unobserve = createObserver(this.$el, () => {
          trackLandingBannerImpression({
            name: 'landing_page',
            creative: this.cardMarketingContent.alt,
            position: `landing_page_${this.position}`,
          })
        })
      }
    },
  },
}
